var map = {
	"./Ace of Cups.jpg": 1256,
	"./Ace of Pentacles.jpg": 1257,
	"./Ace of Swords.jpg": 1258,
	"./Ace of Wands.jpg": 1259,
	"./Death.jpg": 1260,
	"./Eight of Cups.jpg": 1261,
	"./Eight of Pentacles.jpg": 1262,
	"./Eight of Swords.jpg": 1263,
	"./Eight of Wands.jpg": 1264,
	"./Five of Cups.jpg": 1265,
	"./Five of Pentacles.jpg": 1266,
	"./Five of Swords.jpg": 1267,
	"./Five of Wands.jpg": 1268,
	"./Fortitude.jpg": 1269,
	"./Four of Cups.jpg": 1270,
	"./Four of Pentacles.jpg": 1271,
	"./Four of Swords.jpg": 1272,
	"./Four of Wands.jpg": 1273,
	"./Justice.jpg": 1274,
	"./King of Cups.jpg": 1275,
	"./King of Pentacles.jpg": 1276,
	"./King of Swords.jpg": 1277,
	"./King of Wands.jpg": 1278,
	"./Knight of Cups.jpg": 1279,
	"./Knight of Pentacles.jpg": 1280,
	"./Knight of Swords.jpg": 1281,
	"./Knight of Wands.jpg": 1282,
	"./Nine of Cups.jpg": 1283,
	"./Nine of Pentacles.jpg": 1284,
	"./Nine of Swords.jpg": 1285,
	"./Nine of Wands.jpg": 1286,
	"./Page of Cups.jpg": 1287,
	"./Page of Pentacles.jpg": 1288,
	"./Page of Swords.jpg": 1289,
	"./Page of Wands.jpg": 1290,
	"./Queen of Cups.jpg": 1291,
	"./Queen of Pentacles.jpg": 1292,
	"./Queen of Swords.jpg": 1293,
	"./Queen of Wands.jpg": 1294,
	"./Seven of Cups.jpg": 1295,
	"./Seven of Pentacles.jpg": 1296,
	"./Seven of Swords.jpg": 1297,
	"./Seven of Wands.jpg": 1298,
	"./Six of Cups.jpg": 1299,
	"./Six of Pentacles.jpg": 1300,
	"./Six of Swords.jpg": 1301,
	"./Six of Wands.jpg": 1302,
	"./Temperance.jpg": 1303,
	"./Ten of Cups.jpg": 1304,
	"./Ten of Pentacles.jpg": 1305,
	"./Ten of Swords.jpg": 1306,
	"./Ten of Wands.jpg": 1307,
	"./The Chariot.jpg": 1308,
	"./The Devil.jpg": 1309,
	"./The Emperor.jpg": 1310,
	"./The Empress.jpg": 1311,
	"./The Fool.jpg": 1312,
	"./The Hanged Man.jpg": 1313,
	"./The Hermit.jpg": 1314,
	"./The Hierophant.jpg": 1315,
	"./The High Priestess.jpg": 1316,
	"./The Last Judgment.jpg": 1317,
	"./The Lovers.jpg": 1318,
	"./The Magician.jpg": 1319,
	"./The Moon.jpg": 1320,
	"./The Star.jpg": 1321,
	"./The Sun.jpg": 1322,
	"./The Tower.jpg": 1323,
	"./The World.jpg": 1324,
	"./Three of Cups.jpg": 1325,
	"./Three of Pentacles.jpg": 1326,
	"./Three of Swords.jpg": 1327,
	"./Three of Wands.jpg": 1328,
	"./Two of Cups.jpg": 1329,
	"./Two of Pentacles.jpg": 1330,
	"./Two of Swords.jpg": 1331,
	"./Two of Wands.jpg": 1332,
	"./Wheel Of Fortune.jpg": 1333
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 338;


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image ^\.\/.*\.jpg$
// module id = 338
// module chunks = 0